import React from 'react';
import classNames from 'classnames';
import { CheckboxInterface } from 'atomic/form/checkbox/checkbox.interface';

import './checkbox.scss';

const Checkbox: React.FC<CheckboxInterface> = React.forwardRef(({
    id,
    value,
    name,
    disabled,
    checked,
    label,
    error,
    onChange,
    onBlur
}: CheckboxInterface, ref: React.Ref<HTMLInputElement>) => {
    return (
        <div className="form-checkbox">
            <input
                name={name}
                value={value}
                ref={ref}
                onChange={onChange}
                onBlur={onBlur}
                className="checkbox"
                type="checkbox"
                id={id.toString()}
                disabled={disabled}
                checked={checked}
            />
            <label
                className={classNames(
                    {
                        ['error']: error,
                        ['disabled']: disabled,
                        ['checked']: checked
                    }
                )}
                aria-label={name}
                htmlFor={id.toString()}
                tabIndex={0}
            >
                { label }
            </label>
            <span>
                {''}
            </span>
        </div>
    );
});

Checkbox.displayName = 'Checkbox';

export default Checkbox;
